import { render, staticRenderFns } from "./SelectionPage.vue?vue&type=template&id=6c06048a&scoped=true"
import script from "./SelectionPage.vue?vue&type=script&lang=ts"
export * from "./SelectionPage.vue?vue&type=script&lang=ts"
import style0 from "./SelectionPage.vue?vue&type=style&index=0&id=6c06048a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c06048a",
  null
  
)

export default component.exports